enum ActionEvents{
    inputChange = "input-change", 
}

export default ActionEvents;
  